import React, { useState } from 'react';
import { Label, Input, Button, FormGroup, Row, Col } from 'reactstrap';
import '../assets/css/login.css';
import carewindow_blue from '../assets/images/carewindow_blue.png';
import { EmailCodeforPortalLogin, PostLogin } from '../utils/apis';
import { hasValue, ProcessAPIError, CreateLoginSession } from '../utils/common_functions';

const Login = () => {

    const [email, setEmail] = useState('');

    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [isCodeSent, setisCodeSent] = useState(false);

    const emailChange = async (value) => {
        setError("");
        setEmail(value);
    }

    const handleSendCode = async () => {
        setError('');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!email || !emailRegex.test(email)) {
            setError('Please enter your email address');
            return;
        }

        setLoading(true);
        setisCodeSent(false)

        try {
            await EmailCodeforPortalLogin(email);
            setisCodeSent(true);
        }
        catch (error) {
            setError(ProcessAPIError(error));
        }

        setLoading(false);
    };

    const handleResendCode = async () => {
        setError('');
        try {
            await EmailCodeforPortalLogin(email);
            setSuccess("We have resend the code.");
        }
        catch (error) {
            setError(ProcessAPIError(error));
        }
    };

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (document.getElementById(`otpInput${index + 1}`) && value !== "")
            document.getElementById(`otpInput${index + 1}`).focus();
    };

    const handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text');
        if (hasValue(pastedValue) && pastedValue.length === 6) {
            const newOtp = pastedValue.split('');
            setOtp(newOtp);
            setError('');
        }
    };

    const handleLogin = async () => {
        setError('');

        if (otp.some(value => value === '')) {
            setError('Please enter the full Code');
            return;
        }

        setLoading(true);
        try {
            let obj = { emailId: email, code: otp.join('') }

            let resp = await PostLogin(obj);
            CreateLoginSession(resp.data);

            setTimeout(() => { // Needed for login
                window.location.href = '/features';    
            }, 2000)
        }
        catch (error) {
            setError(ProcessAPIError(error));
        }
        setLoading(false);
    };

    return (
        <div className="login-wrapper">
            <div className="login-form-container">
                <div className="mb-5 mt-4">
                    <img className="login-carewindow" style={{ maxWidth: "100%" }} src={carewindow_blue} alt="CareWindow" />
                </div>
                <div className="mb-3">
                    {error &&
                        <>
                            <FormGroup>
                                <div class="invalid-feedback d-block">
                                    {error}
                                </div>
                            </FormGroup>
                        </>
                    }
                    {success &&
                        <>
                            <FormGroup>
                                <div class="valid-feedback d-block">
                                    {success}
                                </div>
                            </FormGroup>
                        </>
                    }
                    {isCodeSent === false &&
                        <>
                            <Label>Email address</Label>
                            <FormGroup>
                                <Input type="email" id="email" required value={email} onChange={(e) => emailChange(e.target.value)} />
                            </FormGroup>
                            <FormGroup>
                                <Button style={{ width: "100%" }} color="primary" disabled={loading}
                                    onClick={(e) => { e.preventDefault(); handleSendCode(); }}>Sign in</Button>
                            </FormGroup>
                        </>
                    }

                    {isCodeSent === true &&
                        <>
                            <div class="text-center code-label">
                                <Label>We have sent a single-sign-on code to your email address.</Label>
                            </div>
                            <FormGroup>
                                <Label>Enter Code</Label>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    {otp.map((digit, index) => (
                                        <Col key={index} className="pe-0">
                                            <Input type="text" id={`otpInput${index}`} required value={digit} onPaste={handlePaste}
                                                onChange={(e) => handleOtpChange(index, e.target.value.slice(0, 1))} maxLength="1" />
                                        </Col>
                                    ))}
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Button style={{ width: "100%" }} color="primary" onClick={(e) => { e.preventDefault(); handleLogin(); }} disabled={loading}>Sign in</Button>
                            </FormGroup>
                            <div class="mb-3 text-center">
                                <a className="resend-code" onClick={(e) => { e.preventDefault(); handleResendCode(); }} disabled={loading}>
                                    Resend Code
                                </a>
                            </div>
                        </>
                    }
                </div>
                {/*<form id="loginForm" onSubmit={buttonConfig.handler}>*/}

                {/*        {showCodeInput && email === lastVerifiedEmail && (*/}
                {/*            <div className="field">*/}
                {/*                <label className="label_field">Code</label>*/}
                {/*                <input type="text" id="verificationCode" placeholder="Enter verification code"*/}
                {/*                    required value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} className="responsive-input" />*/}
                {/*            </div>*/}
                {/*        )}*/}

                {/*        <div className="field margin_0">*/}
                {/*            <label className="label_field hidden">hidden label</label>*/}
                {/*            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', width: '100%' }}>*/}
                {/*                <button className="btn cur-p btn-primary" type="submit" disabled={isLoading} style={{ width: '120px' }} >*/}
                {/*                    {buttonConfig.text}*/}
                {/*                </button>*/}

                {/*                {showCodeInput && email === lastVerifiedEmail && (*/}
                {/*                    <div style={{ position: 'absolute', right: 0 }}>*/}
                {/*                        {timer > 0 ? (*/}
                {/*                            `${timer}s`*/}
                {/*                        ) : (*/}
                {/*                            <button type="button" onClick={handleSendCode} className="btn-link" style={{ border: 'none', background: 'none', color: '#898989', cursor: 'pointer' }} >*/}
                {/*                                Resend Code*/}
                {/*                            </button>*/}
                {/*                        )}*/}
                {/*                    </div>*/}
                {/*                )}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </fieldset>*/}
                {/*</form>*/}

                {/*{error && (*/}
                {/*    <div className="error-message" style={{*/}
                {/*        fontWeight: '700',*/}
                {/*        color: 'red',*/}
                {/*        marginTop: '10px',*/}
                {/*        textAlign: 'center'*/}
                {/*    }}>*/}
                {/*        {error}*/}
                {/*    </div>*/}
                {/*)}*/}

                {/*{isLoading && (*/}
                {/*    <div className="loading-message" style={{*/}
                {/*        textAlign: 'center',*/}
                {/*        marginTop: '10px'*/}
                {/*    }}>*/}
                {/*        Loading...*/}
                {/*    </div>*/}
                {/*)}*/}
            </div >
        </div >
    );
}

export default Login;